export enum localstorageKeys {
  LocalItems = 'LocalItems',
  DeliveryType = 'deliveryType',
  webId = 'webId',
  timeStamp = 'timeStamp',
  tableId = 'table_id',
  restaurantId = 'restaurant_id',
  customerId = 'customer_id',
  token = 'token',
  restaurant = 'slug',
}
